export const home = '/';
export const history = '/nuestra-historia';
export const affiliation = '/formulario-afiliacion';
export const directory = '/directorio';
export const projects = '/proyectos';
export const coworking = '/espacios-de-trabajo';
export const courses = '/capacitaciones';
export const contact = '/contacto';
export const notFound = '*';
